import { render } from "./AllCountries.vue?vue&type=template&id=5db0e39d&scoped=true"
import script from "./AllCountries.vue?vue&type=script&lang=js"
export * from "./AllCountries.vue?vue&type=script&lang=js"

import "./AllCountries.vue?vue&type=style&index=0&id=5db0e39d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db0e39d"]])

export default __exports__